<script>
export default {
  props: {
    descricao: {
      type: String
    }
  }
}
</script>

<template>
  <div v-if="descricao" class="mt-2">
    <div>
      <span class="title-praticas">Descrição</span>
      <hr />
    </div>
    <el-row class="descricao-pratica">
      <el-col :span="24">
        <p v-html="descricao" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Descricao.vue